module.exports = __webpack_public_path__ + "media/images/sp/shop/step-02-794e91c495efbf7cb3996fec8eac0524.png";